import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/constants';

const NetworkInterceptor = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const updateOnlineStatus = () => {
      if (!navigator.onLine) {
        navigate(ROUTES.NO_INTERNET);
      } else if (location.pathname === ROUTES.NO_INTERNET) {
        navigate(-1);
      }
    };

    globalThis.addEventListener('online', updateOnlineStatus);
    globalThis.addEventListener('offline', updateOnlineStatus);

    return () => {
      globalThis.removeEventListener('online', updateOnlineStatus);
      globalThis.removeEventListener('offline', updateOnlineStatus);
    };
  }, [navigate, location.pathname]);

  return null;
};

export default NetworkInterceptor;
